/* L'CRÉATIF · Maison — interaction layer (drawer, reveals, smooth anchors) */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* safety: never leave the page scroll-locked unless the maison drawer is open
     (the inherited theme.js locks body overflow for drawers maison doesn't render) */
  function ensureScroll() {
    var d = document.querySelector('.m-drawer');
    if (!d || !d.classList.contains('is-open')) document.body.style.overflow = '';
  }
  ensureScroll();
  window.addEventListener('pageshow', ensureScroll);
  window.addEventListener('load', ensureScroll);

  /* mobile drawer */
  var drawer = document.querySelector('.m-drawer');
  var overlay = document.querySelector('.m-drawer__overlay');
  function openD() { if (drawer) drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeD() { if (drawer) drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (b) { b.addEventListener('click', openD); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeD); });

  /* reveal-on-scroll */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.m-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.m-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* smooth-scroll anchors */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"], a[data-scroll]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.charAt(0) !== '#' || id.length < 2) return;
    var t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* product variant sync — keep the displayed price and BOTH add-to-cart buttons
     (incl. the sticky bar, which lives outside the product form) in step with the
     Size selection, so the price shown always matches the variant that is added */
  document.querySelectorAll('.product-page__variant-select').forEach(function (sel) {
    var scope = sel.closest('.product-page');
    if (!scope) return;
    var priceEls = scope.querySelectorAll('[data-price-main], [data-price-sticky]');
    var addButtons = scope.querySelectorAll('[data-add-to-cart]');
    function sync() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price');
      if (price) priceEls.forEach(function (el) { el.textContent = price; });
      addButtons.forEach(function (b) { b.setAttribute('data-variant-id', opt.value); });
    }
    sel.addEventListener('change', sync);
    sync();
  });

  /* background videos: honour reduced-motion everywhere, and pause when off-screen
     (saves data/CPU and eases WCAG 2.2.2 — no layout change) */
  var vids = document.querySelectorAll('video[autoplay]');
  if (vids.length) {
    if (reduce) {
      vids.forEach(function (v) { try { v.autoplay = false; v.removeAttribute('autoplay'); v.pause(); } catch (e) {} });
    } else if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.15 });
      vids.forEach(function (v) { vio.observe(v); });
    }
  }
})();
